/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Faq_Q4_AnswerInputs */

const en_faq_q4_answer = /** @type {(inputs: Faq_Q4_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`If your insurance was arranged by your agent, it’s best to contact the agent to see if you are eligible for a refund. If you purchased your insurance online, send an email to ${i?.email} to cancel your insurance and see if you are eligible for a refund.`)
};

const fr_faq_q4_answer = /** @type {(inputs: Faq_Q4_AnswerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Si votre assurance a été organisée par votre agent, il est préférable de contacter l'agent pour voir si vous êtes admissible à un remboursement. Si vous avez acheté votre assurance en ligne, envoyez un courriel à ${i?.email} pour annuler votre assurance et voir si vous êtes admissible à un remboursement.`)
};

/**
* | output |
* | --- |
* | "If your insurance was arranged by your agent, it’s best to contact the agent to see if you are eligible for a refund. If you purchased your insurance online,..." |
*
* @param {Faq_Q4_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q4_answer = /** @type {((inputs: Faq_Q4_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q4_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q4_answer(inputs)
	return fr_faq_q4_answer(inputs)
});